const languageMenu = document.getElementById("language-menu");
const currentUrl = window.location.href;
const urlObj = new URL(currentUrl);
const currentPathname = urlObj.pathname;
const currentSearch = urlObj.search;

function generateLanguageLink(lang) {
  if (urlObj.hostname === "localhost" || urlObj.hostname.startsWith("127.0.0.")) {
    return `${urlObj.origin}${currentPathname}?lang=${lang}`;
  } else {
    const domain = urlObj.hostname.replace(/^(en\.|ua\.|ru\.|es\.|br\.|fr\.|de\.|tr\.)/, "");
    let newHost;
    if (lang === "en") {
      newHost = domain;
    } else {
      newHost = `${lang}.${domain}`;
    }
    return `${urlObj.protocol}//${newHost}${currentPathname}${currentSearch}`;
  }
}

languageMenu.querySelectorAll("a").forEach((link) => {
  const lang = link.dataset.lang;
  link.href = generateLanguageLink(lang);

  link.addEventListener("click", function (event) {
    event.preventDefault();
    window.location.href = this.href;
  });
});
